if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){

    /*
        HOME ARROW
        $('.arrow-home').click(function(event) {
            $('body, html').animate({
                scrollTop: $(window).height()-$('header').outerHeight()*2},
                800, 'easeOutExpo');
        });
    */

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));


    $('.sym-slides').slick({
        accessibility: false
    });

    // tabs slider
    $('.tabs-sym-slide').slick({
        accessibility: true,
        asNavFor:'#slider-bg-images',
        fade:true,
        arrows:false,
        adaptiveHeight:true,
        autoplay:true,
        autoplaySpeed:6000
    });
    $('.js-tabs-item').click(function(){
        let currentTarget = $(this).attr('data-target');
        $('.tabs-sym-slide').slick('slickGoTo', currentTarget);
        $('.js-tabs-item').each(function(){
            if( $(this).attr('data-target') == currentTarget){
                $(this).addClass('active')
            } else {
                $(this).removeClass('active')
            }
        });
    });
    $('.tabs-sym-slide').on('afterChange', function(event, slick, currentSlide){
   
        $('.js-tabs-item').each(function(){
            if( $(this).attr('data-target') == currentSlide){
                $(this).addClass('active')
            } else {
                $(this).removeClass('active')
            }
        });
    });
    $('.slider-images-arrow').click(function(){
        $('.tabs-sym-slide').slick('slickNext');
        let currentTarget = $('.tabs-sym-slide .slick-active').attr('data-slick-index');
        $('.js-tabs-item').each(function(){
            if( $(this).attr('data-target') == currentTarget){
                $(this).addClass('active')
            } else {
                $(this).removeClass('active')
            }
        });
    })

    if(document.getElementsByClassName('btn').length > 0){
        let allBtn = document.getElementsByClassName('btn');
        let allBtnLength = allBtn.length;
        for(let i=0; i < allBtnLength; i++){
            if(!allBtn[i].parentElement.classList.contains('form-module__submit')){
                let innerT = allBtn[i].innerHTML;
                allBtn[i].innerHTML = '<span>'+ innerT +'</span>';
            }
            
        }
    }
	//
    if(document.getElementsByClassName('no-follow').length > 0){
        let allNoFollow = document.getElementsByClassName('no-follow');
        let allNoFollowLength = allNoFollow.length;
        for(let i=0; i < allNoFollowLength; i++){
            allNoFollow[i].addEventListener('click', function(e){
				e.preventDefault();
			});
        }
    }



    //email signup animation 
	if(document.getElementById('email-signup_FNAME')){
		document.getElementById('email-signup_FNAME').addEventListener('focus', function(){
			this.parentElement.classList.add('moved');
		})
        document.getElementById('email-signup_LNAME').addEventListener('focus', function(){
			this.parentElement.classList.add('moved');
		})
		document.getElementById('email-signup_email_address').addEventListener('focus', function(){
			this.parentElement.classList.add('moved');
		})
	}
    //CMS forms label animation
	if(document.getElementsByClassName('form-module__field').length > 0){
		let allffields = document.getElementsByClassName('form-module__field');
		
	   for(let j = 0; j < allffields.length; j++){
		   
		   if(allffields[j].getElementsByTagName('input').length > 0){
			   if(allffields[j].getElementsByTagName('input')[0].type.toLowerCase() != 'checkbox' && allffields[j].getElementsByTagName('input')[0].type.toLowerCase() != 'radio'){
				   allffields[j].getElementsByTagName('input')[0].addEventListener('focus', function(){
					   this.parentElement.classList.add('moved');
				   })
			   }
		   }
		   if(allffields[j].getElementsByTagName('select').length > 0){
			   allffields[j].getElementsByTagName('select')[0].addEventListener('focus', function(){
				   this.parentElement.classList.add('moved');
			   })
		   }
		   if(allffields[j].getElementsByTagName('textarea').length > 0){
			   allffields[j].getElementsByTagName('textarea')[0].addEventListener('focus', function(){
				   this.parentElement.classList.add('moved');
			   })
		   }
	   }
	}

    

    //vanilla JS fancybox
	if(document.getElementsByClassName('lightbox').length > 0){
		let allLightboxes = document.getElementsByClassName('js-lightboxbtn');
		let allLightboxesLength = allLightboxes.length;

		for(let j = 0; j < allLightboxesLength; j++ ){
			allLightboxes[j].addEventListener('click', function(e){
				e.preventDefault();
				let currentTarget = this.getAttribute('href').split('#')[1];
				if(!document.getElementById(currentTarget).classList.contains('open')){
					document.getElementById(currentTarget).classList.add('open')
				} else {
					document.getElementById(currentTarget).classList.remove('open')
				}
			});
		}

		let allLightcloses = document.getElementsByClassName('js-lightboxclose');
		let allLightclosesLength = allLightcloses.length;

		for(let j = 0; j < allLightclosesLength; j++ ){
			allLightcloses[j].addEventListener('click', function(e){
				e.preventDefault();
				let currentTarget = this.parentElement.parentElement.id;
				if(!document.getElementById(currentTarget).classList.contains('open')){
					document.getElementById(currentTarget).classList.add('open')
				} else {
					document.getElementById(currentTarget).classList.remove('open')
				}
			});
		}
	}



})();